<template>
  <div class="relative min-w-[360px] min-h-[320px]">
    <div
      class="absolute right-2 top-0 w-10 h-5 z-20 pointer-events-none flex"
      :style="{
        background: backgroundColor && backgroundColor !== 'transparent' ? backgroundColor : '#F0F5F8'
      }">
      <Download :color="textColor" class="ml-auto" />
    </div>

    <apexchart :id="chartid" :options="chart_options" :series="datasets[0].data" :height="height * 18" />
  </div>
</template>

<script>
import { Download } from "lucide-vue-next"

export default {
  name: "Chart",
  components: {
    Download
  },
  props: {
    height: null,
    textColor: null,
    showDataLabels: null,
    backgroundColor: null,
    labels: {
      type: Array,
      default: () => []
    },
    chartid: {
      type: String,
      default: "chartName"
    },
    chartdata: {
      type: Array,
      default: () => [110, 90, 80, 70]
    },
    hasLegend: {
      type: Boolean,
      default: true
    },
    graphObj: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart_options: {},
      formattedChartData: [],
      toFixedChartData: [],
      formattedLables: [],
      datasets: []
    }
  },
  computed: {
    changed() {
      return this.$store.state.ui.darkMode
    },
    isChecked() {
      return this.hasLegend
    }
  },
  watch: {
    changed() {
      this.generateColors(this.changed)
    },
    height() {
      this.createChart()
    }
  },
  created() {
    this.chartdata.map((x) => {
      this.formattedChartData.push(x.data.map((point) => this.formatPoint(point)))
      this.toFixedChartData.push(x.data.map((point) => this.formatToFixed(point)))
      this.datasets.push({
        ...x,
        name: x.label,
        borderRadius: 13,
        minBarLength: 10,
        borderSkipped: true,
        data: x.data.map((point) => this.formatToFixed(point))
      })
    })
    this.formattedLables = this.labels.map((point) => (Number(point) ? this.formatPoint(Number(point)) : point))

    this.createChart()
  },
  methods: {
    formatPoint(datapoint) {
      return this.$utils.truncateNumber(datapoint)
    },
    formatToFixed(datapoint) {
      return Number(datapoint).toFixed(2)
    },
    createChart() {
      this.chart_options = {
        title: {
          margin: 30,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          text: this.graphObj.name,
          align: "center"
        },
        chart: {
          foreColor: this.textColor,
          height: this.height * 18,
          background: this.$store.state.ui.darkMode ? "#2b3c44" : "transparent",
          type: "polarArea",
          zoom: {
            enabled: true
          },
          toolbar: {
            show: true,
            export: {
              csv: {
                filename: this.graphObj.name
              },
              svg: {
                filename: this.graphObj.name
              },
              png: {
                filename: this.graphObj.name
              }
            },
            autoSelected: "zoom"
          }
        },
        labels: this.labels,
        legend: {
          show: this.isChecked,
          position: "bottom",
          labels: {
            colors: this.$store.state.ui.darkMode ? "white" : this.textColor
          }
        },
        xaxis: {
          categories: this.labels.length ? this.formattedLables : this.formattedChartData,
          labels: {
            show: this.isChecked,
            style: {
              colors: this.$store.state.ui.darkMode ? "white" : this.textColor
            }
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return Math.floor(value)
            },
            show: true,
            style: {
              colors: this.$store.state.ui.darkMode ? "white" : this.textColor
            }
          }
        },
        dataLabels: {
          enabled: this.showDataLabels
        }
      }
    },
    generateColors(isDarkMode) {
      this.chart_options = {
        dataLabels: {
          enabled: this.showDataLabels
        },
        chart: {
          background: this.$store.state.ui.darkMode ? "#2b3c44" : "transparent"
        },
        title: {
          style: {
            color: this.$store.state.ui.darkMode ? "#FFF" : "#000"
          }
        },
        legend: {
          labels: {
            colors: isDarkMode ? "white" : this.textColor
          }
        },
        xaxis: {
          labels: {
            show: this.isChecked,
            style: {
              colors: isDarkMode ? "white" : this.textColor
            }
          }
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              colors: isDarkMode ? "white" : this.textColor
            }
          }
        }
      }
    }
  }
}
</script>
